<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: ['chartData', 'options'],
  data() {
    return {
      defaultOptions: {
        responsive: true, // my new default options
        maintainAspectRatio: false, // my new default options
        // scales: {
        //     yAxes: [{
        //         ticks: {
        //             // Include a dollar sign in the ticks
        //             callback: function (value, index, values) {
        //                 return value + ' €';
        //             },
        //             beginAtZero: true
        //         },
        //         gridLines: {
        //             display: true // my new default options
        //         }
        //     }],
        //     xAxes: [{
        //         gridLines: {
        //             display: false
        //         }
        //     }]
        // }
      },
    };
  },
  mounted() {
    if (this.options) {
      this.defaultOptions = this.options;
    }
    this.renderChart(this.chartData, this.defaultOptions);
  },
  // watch: {
  //     chartData: {
  //         handler: function (val, oldVal) {
  //             this.renderChart(this.chartData, this.defaultOptions)
  //         },
  //         deep: true
  //     }
  // }
};
</script>
